import { Entry } from 'src/services/entry/Entry';
import { Period } from 'src/services/tag/Tag';

export function isWithinCurrentPeriod(entry: Entry, period: Period) {
  const date = entry.date;
  if (date) {
    return (
      date.getFullYear() === period.year && date.getMonth() + 1 === period.month
    );
  } else {
    return false;
  }
}
